// src/components/common/SearchBar.tsx
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Input } from "@/components/ui";

export default function SearchBar() {
    const { t } = useTranslation();

    return (
        <div className="relative hidden md:block w-72">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" strokeWidth={1.5} />
            <Input
                type="text"
                placeholder={t("header.searchPlaceholder")}
                className="w-full h-9 pl-9"
            />
        </div>
    );
} 